/** QC: GOT Hand-over (docs/designs/got-qc-handover.md, screen 1). Backed by /api/v1/got/handover/*. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { QcHandoverPage } from "@/features/got/components/handover-qc-page";

const search = z.object({
  tab: z.enum(["pending", "sent", "received", "gotr"]).default("pending"),
  dispatched: z.boolean().optional(),
  superseded: z.boolean().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
});

export const Route = createFileRoute("/_app/quality/got/handover/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("got.handover_send"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected } = useFacilities();
  return (
    <QcHandoverPage
      search={s}
      facilityId={selected?.id ?? null}
      plantName={selected ? selected.name : null}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
